/**
 * Validate the headers of the uploaded file.
 * @param {Array} headers - The headers from the uploaded file.
 * @returns {boolean} - True if the headers are valid, false otherwise.
 */
export function validateHeadersFile(headers = []) {
    try {
        var expectedHeaders = [
            "Type",
            "Title",
            "First Name",
            "Last Name",
            "Contact Number",
            "Email Address",
            "Flight N",
            "Send Notification"
        ];
        return (
            headers.length !== expectedHeaders.length ||
            !headers.every((h, i) => h === expectedHeaders[i])
        );
    } catch (error) {
        return false;
    }
}

/** Validate a row of data against specific patterns.
 * @param {Object} row - The row of data to validate.
 * @returns {boolean} - True if the row is valid, false otherwise.
 */
export function validateRow(row) {
    const regexPatterns = {
        type: /^(SENIOR|ADULT|CHILD)$/i,
        title: /^(Mr|Mrs|Mx)?$/i,
        emailAddress: /^([\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,})?$/,
        sendNotification: /^(YES|NO)$/i
    };
    for (const [key, regex] of Object.entries(regexPatterns)) {
        if (!regex.test(row[key])) {
            return false;
        }
    }
    return true;
}

/** Parse the content of the uploaded file into a structured format.
 * @param {Array} rows - The rows of data from the uploaded file.
 * @returns {Array} - An array of parsed passenger objects.
 */
export function parseContentFile(rows = []) {
    try {
        return rows
            .map(row => {
                return {
                    type: row["Type"],
                    title: row["Title"],
                    firstName: row["First Name"],
                    lastName: row["Last Name"],
                    fullName: `${row["First Name"]} ${row["Last Name"]}`,
                    emailAddress: row["Email Address"],
                    contactNumber: `${row["Contact Number"]}`,
                    sendNotification: row["Send Notification"],
                    flightNumber: row["Flight N"]
                };
            })
            .filter(row => {
                return (
                    row.type &&
                    row.title &&
                    row.firstName &&
                    row.lastName &&
                    row.fullName
                );
            });
    } catch (error) {
        return [];
    }
}

/**
 * Get the passengers to register from the imported list.
 * @param {*} passengers - The existing passengers.
 * @param {*} importedPassengers - The passengers from the imported file.
 * @returns {Array} - The list of passengers to register.
 */
export function getPassengerToRegister(passengers = [], importedPassengers = []) {
    return importedPassengers.filter(passenger => {
        if (passenger.email || passenger.phone) {
            let isDuplicate = passengers.find(p => {
                return p.email && (p.email === passenger.email) || p.phone && (p.phone === passenger.phone);
            });
            return isDuplicate ? false : true;
        } else {
            return true;
        }
    });
}

/**
 * Get the gender based on the title.
 * @param {string} title - The title of the passenger.
 * @returns {string} - The gender ("male", "female", "other", or "").
 */
export function getGenderByTitle(title) {
    const lowerCaseTitle = title.toLowerCase();
    if (lowerCaseTitle === "mr") {
        return "male";
    } else if (lowerCaseTitle === "mrs") {
        return "female";
    } else if (lowerCaseTitle === "mx") {
        return "other";
    }
    return "";
}